import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Tabs from "../../../DesignSystem/Tabs/Tabs";
import SecondaryButton from "../../../DesignSystem/Buttons/SecondaryButton";
import { subscribeAdviserFullDetailsByEmailOrId } from "../../../../context/Adviser/Utils/AdviserLiveDetails";
import { useUserPermissions } from "../../../SignIn/UserPermissionsContext";
import { CATEGORIES, adviserCategories, canManageFees, sortVersions } from "../../../Compliance/ClientAgreementFeeStructures/feeStructureModel";
import { subscribeFeeStructures } from "../../../Compliance/ClientAgreementFeeStructures/feeStructureService";
import FeeStructureVersionsTable from "../../../Compliance/ClientAgreementFeeStructures/FeeStructureVersionsTable";
import { PostCard } from "../HelperFunctions/HelperFunctions";
import "../../../../css/Compliance/ClientAgreementFeeStructures/ClientAgreementFeeStructures.css";

export default function AdviserFeeStructures({ adviserId, adviserKey }) {
  const navigate = useNavigate();
  const { userPermissions = [] } = useUserPermissions();
  const canManage = canManageFees(userPermissions);
  const canView = canManage || userPermissions.includes("Compliance Support");
  const [details, setDetails] = useState(null);
  const [versions, setVersions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [category, setCategory] = useState("financial-planning");
  useEffect(() => {
    if (!adviserId || !canView) return;
    return subscribeAdviserFullDetailsByEmailOrId(adviserId, setDetails);
  }, [adviserId, canView]);
  useEffect(() => {
    if (!adviserId || !canView) return;
    setLoading(true);
    return subscribeFeeStructures([adviserId], data => { setVersions(data); setLoading(false); }, () => { setError("Could not load fee structures."); setLoading(false); });
  }, [adviserId, canView]);
  if (!canView) return null;
  const application = details?.applicationDetails || {};
  const base = details?.adviserDoc || {};
  const allowed = adviserCategories({ businessAreas: application.businessAreas || base.businessAreas, ARBusinessAreas: application.ARBusinessAreas || base.ARBusinessAreas }, versions.map(v => v.category));
  const tabs = CATEGORIES.filter(c => allowed.includes(c.id));
  const active = tabs.some(c => c.id === category) ? category : tabs[0]?.id;
  const history = sortVersions(versions.filter(v => v.category === active));
  const edit = () => navigate(`/advisers/${encodeURIComponent(adviserKey || adviserId)}/client-agreement/fees/${active}/edit`);
  return <PostCard title="Client Agreement Fee Structures" right={active && canManage && <SecondaryButton label="Edit" onClick={edit} />}>
    {error && <p role="alert">{error}</p>}
    {loading || !details || details.loading ? <p role="status">Loading fee structures...</p> : !active ? <p>No Financial Planning or Mortgages business permissions recorded for this adviser.</p> : <>
      <Tabs tabs={tabs} activeTab={active} onTabChange={setCategory} />
      <FeeStructureVersionsTable versions={history} category={active} />
    </>}
  </PostCard>;
}
